import Standard from './Standard';
import DefaultLayout from './DefaultLayout';
import { NavStyle } from '../../../shared/constants/AppEnums';

const Layouts = {
  [NavStyle.STANDARD]: Standard,
  [NavStyle.DEFAULT]: DefaultLayout,
};
export default Layouts;
